import { useTranslation } from "@next-platform/client-common-core";
import { Input } from "@nextui-org/react";
import { TFunction } from "i18next";
import { useState } from "react";

import { validatePostalCode } from "@/utils";

import { InputPostalCodeProps } from "./types";
// eslint-disable-next-line id-length -- we want to keep 't' as the common convention for translation function
const getPostalTermFromCountry = (countryCode: string, t: TFunction) => {
  const isZipCountry = ["US", "PH", "IR"].includes(countryCode);
  return {
    postalLabel: isZipCountry ? t("subscription:checkout.personalInfo.zip") : t("subscription:checkout.personalInfo.postalCode"),
    invalidLabel: isZipCountry ? t("subscription:checkout.personalInfo.invalidZip") : t("subscription:checkout.personalInfo.invalidPostalCode"),
  };
};

const InputPostalCode = ({ postalCode, countryCode, updatePersonalInfo, variant }: InputPostalCodeProps) => {
  const { t } = useTranslation();
  const [isPostalCodeInvalid, setIsPostalCodeInvalid] = useState(false);

  const { postalLabel, invalidLabel } = getPostalTermFromCountry(countryCode, t);

  return (
    <Input
      isRequired
      maxLength={16}
      label={postalLabel}
      labelPlacement="inside"
      placeholder="12345"
      isInvalid={isPostalCodeInvalid}
      errorMessage={isPostalCodeInvalid ? invalidLabel : ""}
      variant={variant}
      classNames={{ base: "w-30" }}
      value={postalCode}
      onChange={(e) => updatePersonalInfo("postal_code", e.target.value.toUpperCase())}
      onBlur={() => {
        if (postalCode && countryCode) {
          setIsPostalCodeInvalid(!validatePostalCode(postalCode, countryCode));
        }
      }}
      onFocus={() => {
        setIsPostalCodeInvalid(false);
      }}
    />
  );
};

export default InputPostalCode;
